import React from 'react';
import { ArrowUpRight, MessageCircle } from 'lucide-react';
import { serviceCategories, serviceGroups } from '../mock';
import { useServiceEnquiry } from './ServiceEnquiry';

export default function Services() {
  const { openService } = useServiceEnquiry();

  return (
    <section id="services" className="py-12 lg:py-28 bg-wash">
      <div className="section-pad max-w-[1440px] mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8 sm:mb-14">
          <div>
            <span className="eyebrow"><span className="dot" /> Our Services</span>
            <h2 className="font-display mt-4 sm:mt-6 text-3xl sm:text-4xl md:text-5xl lg:text-[3.6rem] font-extrabold leading-[1.05] tracking-tight">
              Protection &amp; styling, <span className="font-serif italic font-normal text-accent-orange">done right.</span>
            </h2>
            <p className="mt-3 sm:mt-4 text-[#5a5548] max-w-xl text-sm sm:text-base">Tap any service to enquire — we’ll continue on WhatsApp.</p>
          </div>
          <span className="hidden sm:inline text-[0.62rem] font-mono tracking-widest text-[#8a8578] border border-black/10 rounded-full px-4 py-2">CLICK TO ENQUIRE</span>
        </div>

        <div className="grid sm:grid-cols-3 gap-3 sm:gap-4 mb-6 sm:mb-10">
          {serviceGroups.map((g) => (
            <div key={g.index} className="card-elevated rounded-2xl p-4 sm:p-6 hover:-translate-y-1 transition-transform duration-500">
              <div className="flex items-center gap-3 mb-4">
                <span className="font-display text-sm font-bold text-[#ff5a1f]">{g.index}</span>
                <span className="h-px flex-1 bg-black/8" />
                <span className="text-[0.62rem] font-semibold tracking-widest text-[#8a8578]">{g.kicker}</span>
              </div>
              <h3 className="font-display text-xl font-bold text-[#16150f] mb-4">{g.title}</h3>
              <div className="flex flex-wrap gap-2">
                {g.items.map((item) => (
                  <button
                    key={item}
                    type="button"
                    onClick={() => openService(item, { category: g.title })}
                    className="text-[0.78rem] text-[#4a463d] bg-[#faf8f3] border border-black/6 rounded-full px-3 py-1.5 hover:bg-[#ff5a1f] hover:text-white hover:border-[#ff5a1f] transition-colors"
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {serviceCategories.map((s) => (
            <div key={s.index} className="group card-elevated rounded-[1.6rem] overflow-hidden hover:-translate-y-2 transition-all duration-500">
              <div className="relative h-44 sm:h-56 overflow-hidden">
                <img src={s.img} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <span className="absolute top-4 left-4 text-[0.6rem] font-semibold tracking-widest text-[#16150f] bg-white/90 backdrop-blur px-2.5 py-1 rounded-full">{s.tag}</span>
              </div>
              <div className="p-5 sm:p-7">
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-display text-sm font-bold text-[#ff5a1f]">{s.index}</span>
                  <span className="h-px flex-1 bg-black/8" />
                  <h3 className="font-display text-xl font-bold text-[#16150f]">{s.title}</h3>
                </div>
                <p className="text-sm text-[#5a5548] leading-relaxed mb-5">{s.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {s.items.map((item) => (
                    <button
                      key={item}
                      type="button"
                      onClick={() => openService(item, { category: s.title, image: s.img })}
                      className="group/chip inline-flex items-center gap-1.5 text-[0.72rem] text-[#4a463d] bg-[#faf8f3] border border-black/6 rounded-full px-3 py-1.5 hover:bg-[#16150f] hover:text-white hover:border-[#16150f] transition-colors"
                    >
                      {item}
                      <ArrowUpRight className="w-3 h-3 opacity-40 group-hover/chip:opacity-100" />
                    </button>
                  ))}
                </div>
                <p className="mt-5 flex items-center gap-2 text-[0.68rem] tracking-widest text-[#8a8578]">
                  <MessageCircle className="w-3.5 h-3.5 text-[#25D366]" /> TAP A SERVICE · WHATSAPP QUOTE
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
